import React, { createContext, useContext } from 'react'
import type { SmpteController } from '@/organisms/AngelPlayer/BitmovinPlayer/types'

interface HlsPlayerUIContextValue {
  /** Current playback time in seconds. */
  currentTime: number
  /** Total duration of the video in seconds. */
  duration: number
  /** Furthest buffered time in seconds. */
  buffered: number
  /** Whether the video is currently playing. */
  playing: boolean
  /** Current volume on a 0–100 scale. */
  volume: number
  /** Whether the video is muted. */
  muted: boolean
  /** Whether the player container is in fullscreen mode. */
  fullscreen: boolean
  /** Whether the video is buffering (waiting for data). */
  waiting: boolean
  /** The player controller for issuing playback commands. */
  controller: SmpteController | null
  /** Video title displayed in the title bar overlay. */
  title?: string
  /** Ref to the underlying video element (needed for PiP API). */
  videoRef: React.RefObject<HTMLVideoElement | null>
}

const HlsPlayerUIContext = createContext<HlsPlayerUIContextValue | null>(null)

export const HlsPlayerUIProvider = HlsPlayerUIContext.Provider

export function useHlsPlayerUI(): HlsPlayerUIContextValue {
  const ctx = useContext(HlsPlayerUIContext)
  if (!ctx) {
    throw new Error('useHlsPlayerUI must be used within an HlsPlayerUIProvider')
  }
  return ctx
}
